export default __webpack_public_path__ + "static/media/hello-light.87c00d24.png";